/** Largest single data-channel message we send. SCTP rejects messages
 *  over the negotiated max (64 KiB when the peer advertises none), so a
 *  larger frame goes out as consecutive messages; the box decodes frames
 *  from the concatenated byte stream. */
export const DC_MAX_MESSAGE_BYTES = 16 * 1024;

/** Send `buf` as one or more messages of at most `DC_MAX_MESSAGE_BYTES`. */
export function sendInChunks(
  dc: { send(data: ArrayBuffer): void },
  buf: ArrayBuffer,
): void {
  if (buf.byteLength <= DC_MAX_MESSAGE_BYTES) {
    dc.send(buf);
    return;
  }
  for (let off = 0; off < buf.byteLength; off += DC_MAX_MESSAGE_BYTES) {
    dc.send(buf.slice(off, off + DC_MAX_MESSAGE_BYTES));
  }
}
